import { getColor } from '@theme-ui/color';

import { useTheme } from '../../hooks/useTheme';

export function useSunriseColor(name: string): string {
	return getColor(useTheme(), name) as string;
}
